import { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../context/authContext";
import Carging from "./Carging";

import Firma from "./Firma";
const LoginForm = () => {
    const { signIn, googleSignIn } = useContext(AuthContext);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [googleLoading, setGoogleLoading] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        signIn(email, password)
            .then(() => {
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                setError(error.message);
            })
    }

    return (
        <form
            onSubmit={(e) => handleSubmit(e)}
            autoComplete="off"
            className="p-5 m-5 col-12 col-md-8 h-100 d-flex flex-column justify-content-center">

            <h4 className="mb-5 text-center d-flex d-md-none">
                <Firma />
            </h4>
            <h4
                className="fs-2">
                Welcome Back
            </h4>
            <small className="mb-5">
                Please enter your credentials to login
            </small>
            <div className="form-floating mb-3">
                <input
                    autoComplete="off"
                    value={email}
                    onChange={(e) => { setEmail(e.target.value); setError('') }}
                    type="email"
                    className={`form-control ${error ? "is-invalid" : ""}`}
                    id="floatingInput"
                    placeholder="name@example.com"
                    required
                />
                <label htmlFor="floatingInput">Email address</label>
            </div>
            <div className="form-floating mb-3">
                <input
                    required
                    value={password}
                    onChange={(e) => { setPassword(e.target.value); setError('') }}
                    autoComplete="off"
                    type="password"
                    className={`form-control ${error ? "is-invalid" : ""}`}
                    id="floatingPassword"

                    placeholder="Password" />
                <label htmlFor="floatingPassword">Password</label>
            </div>
            <div className="form-floating mb-3 d-flex justify-content-end small">
                <Link to="/forgot" className="n-link">Forgot your password</Link>
            </div>
            {error ? <small className="text-danger mb-1">{error}</small> : <small className="mb-1">&nbsp;</small>}
            <button type="submit" className="btn btn-primary mb-4 d-flex justify-content-around align-items-center">
                <span>Sign in</span>
                <span>
                    {loading ?

                        <Carging />
                        :
                        <i className="bi bi-send"></i>
                    }
                </span>
            </button>

            <button
                onClick={() => {
                    setGoogleLoading(true);
                    googleSignIn()
                        .then(() => {
                            setGoogleLoading(false);
                        })
                        .catch((error) => {
                            setGoogleLoading(false);
                            setError(error.message);
                        })
                }}
                type="button"
                className="btn btn-default border d-flex justify-content-around align-items-center"
                disabled={loading}
            >
                <span>Sign in width Google</span>
                {googleLoading ? <Carging /> : <span><i className="bi bi-google"></i></span>}
            </button>
        </form>
    )
}

export default LoginForm;